<script>
  import _base from '../../_default/components/_base.vue'

  export default{
    name: 'usuarios',
    extends: _base,
    data () {
      return {}
    },
    computed: {},
    mounted () {},
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
    <div class="app-content">
        <div class="app-content-body comitentes">
            <router-view></router-view>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?5b33e20c